export const DISPLAYED_GRID_ROWS_COUNT = 10;
export const DATA_GRID_FIRST_PAGE = 0;
